import ErrorMessage from '../../ErrorMessage';
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // ErrorMessage is BLS-branded (the-buyer-logo). Gitcha routes must pass
      // their own fallback rather than render another product's logo.
      if (this.props.fallback) return this.props.fallback;
      return <ErrorMessage message="Something went wrong, Please try again later." />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
